module.exports = __webpack_public_path__ + "img/D202207_1.17a15ba4.jpg";